import { formatBytes } from "@helpers";
import { Column } from "react-table";

export default [
    {
        Header: 'Name',
        accessor: row => `${row.first_name} ${row.last_name}`,
        width: "100%"
    },
    {
        Header: 'Email',
        accessor: 'email'
    },
    {
        Header: 'Country',
        accessor: row => row.country?.name
    },
    {
        Header: 'Size',
        accessor: row => parseInt(row.photos_sum_size),
        Cell: ({ value }: any) => formatBytes(value),
        width: 90
    }
] as Column<Interfaces.Customer.Includes<"photos_sum_size">>[]